export default {
  name: "Jina",
  tel: "Simu",
  save: "kuokoa",
  confirm: "Thibitisha",
  cancel: "Ghairi",
  delete: "Futa",
  complete: "Maliza",
  loading: "Inapakia ...",
  telEmpty: "Tafadhali jaza nambari yako ya simu",
  nameEmpty: "Tafadhali jaza jina lako",
  nameInvalid: "Tafadhali ingiza jina halali",
  confirmDelete: "Je! Una uhakika unataka kuifuta",
  telInvalid: "Tafadhali ingiza nambari sahihi ya simu",
  vanCalendar: {
    end: "Maliza",
    start: "Anza",
    title: "Kichwa",
    confirm: "Thibitisha",
    startEnd: "Anza mwisho",
    weekdays: {
      "0": "siku",
      "1": "moja",
      "2": "mbili",
      "3": "tatu",
      "4": "Nne",
      "5": "tano",
      "6": "sita"
    }
  },
  vanCascader: { select: "Tafadhali chagua" },
  vanContactCard: { addText: "Ongeza mawasiliano" },
  vanContactList: { addText: "Mtu mpya wa mawasiliano" },
  vanPagination: { prev: "Ukurasa uliopita", next: "Ukurasa unaofuata" },
  vanPullRefresh: {
    pulling: "Vuta chini ili kuburudisha ...",
    loosing: "Toa kiburudisho ..."
  },
  vanSubmitBar: { label: "Yote:" },
  vanCoupon: { unlimited: "Hakuna vizuizi vya matumizi" },
  vanCouponCell: { title: "Kuponi", tips: "haipatikani" },
  vanCouponList: {
    empty: "Hakuna kuponi",
    exchange: "kubadilishana",
    close: "Hakuna kuponi",
    enable: "Inapatikana",
    disabled: "haipatikani",
    placeholder: "Tafadhali ingiza nambari ya punguzo"
  },
  vanAddressEdit: {
    area: "eneo",
    postal: "Nambari ya Posta",
    areaEmpty: "Chagua mkoa",
    addressEmpty: "Tafadhali jaza anwani ya kina",
    postalEmpty: "Fomati ya nambari ya posta sio sahihi",
    defaultAddress: "Weka kama anwani ya usafirishaji wa kawaida",
    telPlaceholder: "Nambari ya rununu",
    namePlaceholder: "Jina la mjumbe",
    areaPlaceholder: "Chagua mkoa/jiji/wilaya"
  },
  vanAddressEditDetail: {
    label: "Anwani",
    placeholder:
      "Nambari ya mlango wa barabara, nambari ya chumba cha sakafu na habari nyingine"
  },
  vanAddressList: { add: "Ongeza anwani" }
};
